<template>
    <rkm-area title="Autorização">
        <div>
            <rkm-row>
                <rkm-col cols="5">
                    <rkm-form-input-autocomplete
                        :repository="repositories.usuario"
                        :search-fields="fields.autocompletes.profissionalAutorizador"
                        :validations="validations.profissionalAutorizador"
                        label="Nome do profissional autorizador"
                        v-model="model.profissionalAutorizador"
                        text-field="cidadaoNome"
                    />
                </rkm-col>
    
                <rkm-col cols="4">
                    <rkm-form-input
                        :disabled="disabledDocumentoNumero"
                        :label="false"
                        :mask="documentoNumeroMask"
                        :readonly="!model.profissionalAutorizadorDocumentoTipoId"
                        :validations="validations.documentoNumero"
                        name="Número do documento"
                        v-model="model.profissionalAutorizadorDocumentoNumero"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-form-radio-group
                                    :disabled="!model.profissionalAutorizador"
                                    :options="form.documentos"
                                    text-field="nome"
                                    v-model="model.profissionalAutorizadorDocumentoTipoId"
                                    value-field="id"
                                />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
    
                <rkm-col cols="3">
                    <rkm-form-date-picker
                        :disabled="!model.profissionalAutorizador"
                        :max-date="additionals.dataAtual"
                        :validations="validations.dataAutorizacao"
                        label="Data da autorização"
                        right
                        v-model="model.dataAutorizacao"
                    />
                </rkm-col> 
    
            </rkm-row>
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!model.profissionalAutorizador"
                        :validations="validations.codigoOrgaoEmissor"
                        label="Código do órgão emissor"
                        v-model="model.codigoOrgaoEmissor"
                    />
                </rkm-col>
            </rkm-row>
        </div>
    </rkm-area>
</template>

<script>
import tipoDocumento from '@/enums/cadastro/documentoTipo'

import { repository, mask } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                autocompletes: {
                    profissionalAutorizador: [
                        { key: 'cadastroCidadao.nome', searchable: true },
                    ]
                }
            }
        },
        validations() {

            return {
                profissionalAutorizador: {},
                documentoNumero: {
                    cns: this.model.profissionalAutorizadorDocumentoTipoId === this.enums.tipoDocumento.CNS,
                    cpf: this.model.profissionalAutorizadorDocumentoTipoId === this.enums.tipoDocumento.CPF
                },
                dataAutorizacao: {},
                codigoOrgaoEmissor: { max: 6 },
            }
        },
        documentoNumeroMask() {

            switch (this.model.profissionalAutorizadorDocumentoTipoId) {

                case this.enums.tipoDocumento.CNS: {

                    return this.mask.cns
                }
                case this.enums.tipoDocumento.CPF: {

                    return this.mask.cpf
                }
                default: {

                    return ''
                }
            }
        },
        disabledDocumentoNumero() {

            if (!this.model.profissionalAutorizador) {

                return true
            }

            switch (this.model.profissionalAutorizadorDocumentoTipoId) {

                case this.enums.tipoDocumento.CNS: {

                    return !!this.model.profissionalAutorizador.cidadaoCns
                }
                case this.enums.tipoDocumento.CPF: {

                    return !!this.model.profissionalAutorizador.cidadaoCpf
                }
                default: {

                    return false
                }
            }
        }
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')
        }
    },
    methods:{
        normalizeCns(profissional) {
            return profissional?.cidadaoCns
                ?? profissional?.cidadao?.cns
                ?? null
        },
        normalizeCpf(profissional) {
            return profissional?.cidadaoCpf
                ?? profissional?.cidadao?.cpf
                ?? null
        }
    },
    data: () => ({
        enums: { tipoDocumento },
    }),
    mixins: [repository, mask],
    props: {
        additionals: { type: Object, required: true },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'model.profissionalAutorizador'(profissional) {

            if (!profissional) {

                this.model.profissionalAutorizadorDocumentoTipoId = null
                this.model.dataAutorizacao = null
                this.model.codigoOrgaoEmissor = ''
            }
        },
        'model.profissionalAutorizadorDocumentoTipoId'(id) {

            this.$nextTick().then(() => {

                switch (id) {

                    case this.enums.tipoDocumento.CNS: {

                        this.model.profissionalAutorizadorDocumentoNumero = this.normalizeCns(this.model.profissionalAutorizador)

                        break
                    }
                    case this.enums.tipoDocumento.CPF: {

                        this.model.profissionalAutorizadorDocumentoNumero = this.normalizeCpf(this.model.profissionalAutorizador)

                        break
                    }
                    default: {

                        this.model.profissionalAutorizadorDocumentoNumero = ''

                        break
                    }
                }
            })
        }
    }
}
</script>